export const drugUnit = [
  {
    label: 'Pill',
    value: 'pill',
  },
  {
    label: 'Mls',
    value: 'mls',
  },
]